import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { DealConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { DealService } from './api/deal.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class DealApiModule {
    public static forRoot(configurationFactory: () => DealConfiguration): ModuleWithProviders<DealApiModule> {
        return {
            ngModule: DealApiModule,
            providers: [ { provide: DealConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: DealApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('DealApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
